import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'downloading': false,
  'orderType': '',
  'status': '',
  'user': '',
  'partCode': '',
  'orderCode': '',
  'agency': '',
  'list': [],
};

export const ordersGroupedManagement = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.RESTORE_ORDERS_GROUPED_MANAGEMENT]: (state, action) => INITIAL_STATE,
    [ActionTypes.EDIT_ORDERS_GROUPED_MANAGEMENT_FILTER]: (state, action) => ({
      ...state,
      [action.payload.field]: action.payload.value,
    }),
    [ActionTypes.GET_DEALER_ORDERS_TRACKING_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_DEALER_ORDERS_TRACKING_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.GET_DEALER_ORDERS_TRACKING_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.DOWNLOAD_DEALER_ORDERS_REQUEST]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOAD_DEALER_ORDERS_SUCCESS]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
    [ActionTypes.DOWNLOAD_DEALER_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
  })(state, action);
};
